// var helper = require( 'three.fbo-helper' )

import renderer from '../renderer'

import emitter from '../emitter'

import { FBO_DEBUG } from './constants'

import EVENTS from './eventslist'

var FBOHelper = null


if ( FBO_DEBUG ) {

	var FBOHelper = new helper( renderer );

	console.log('NEW FBOOO HELPER')

	FBOHelper.setSize( window.innerWidth, window.innerHeight );

	emitter.on(EVENTS.resize, (w, h)=>{

		FBOHelper.setSize( w, h );
	})

	emitter.on(EVENTS.postupdate, ()=>{

		FBOHelper.update()
	})


} 

export default FBOHelper



// WEBPACK FOOTER //
// ./src/scripts/Trail/globals/fbohelper.js